import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function AddUserIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="#fff" strokeLinecap="round" strokeLinejoin="round" d="M8 9.639H5.3c-.837 0-1.256 0-1.597.105a2.42 2.42 0 0 0-1.6 1.63C2 11.72 2 12.147 2 13m9.2 1V8.333m-2.8 2.834H14M9.5 4.75c0 1.519-1.209 2.75-2.7 2.75S4.1 6.269 4.1 4.75 5.309 2 6.8 2s2.7 1.231 2.7 2.75" /></svg>
  );
}

export default AddUserIcon;
